module.exports = __webpack_public_path__ + "static/img/15.6016279a.png";